var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindpulsComet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1011 512",
    width: 1011,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1482,
    y: 808,
    width: 1011,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1482 -808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M837.828 494.336C798.784 506.356 719.583 503.885 665.47 490.65 579.723 470.47 330.727 354.61 186.679 249.527 391.372 316.399 624.274 353.045 627.144 340.381 629.795 329.589 534.616 297.813 427.209 263.273 395.546 253.358 359.944 241.776 319.099 228.279 168.064 178.384-3.28304 96.9181 0.304433 81.6949 4.58149 63.9281 222.852 63.4157 352.226 86.8867 540.679 121.383 670.522 154.037 674.227 139.398 677.685 126.617 441.005 44.2304 242.197 12.4091 417.411-15.6677 724.606 10.3043 809.182 30.7182 874.104 47.0813 940.066 87.3979 973.251 148.377 1003.39 204.18 1010.79 257.628 1001.49 306.397 992.187 355.18 966.924 407.356 930.765 444.251 906.133 469.388 870.384 484.304 837.828 494.336",
    stroke: "#002C3B",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#072B62",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 1484.5 1317.5)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindpulsComet);
export default __webpack_public_path__ + "static/media/windpuls_comet.1332c63a8908a51f50a68cea3201500b.svg";
export { ForwardRef as ReactComponent };